import React, { useState } from 'react';
import { TableActions } from './components/TableActions/TableActions';
import { TableContent } from './components/TableContent/TableContent';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { useFlowTable } from './useFlowTable';
import { UserType } from '../../EstatePlanningFlow.meta';
import { Loading } from '../../../../../../../../CommonComponents/OPL/Loading/Loading';

interface Props {
  userType: UserType;
}

export const FlowTable = ({ userType }: Props) => {
  const [tableHeight, setTableHeight] = useState(120);

  const isSpouse = userType === UserType.Partner;

  const { data: flowTableData, actions } = useFlowTable({
    isSpouse,
  });

  const {
    queryInfo: { isLoading, data },
    filteredCategoriesAndHeaders,
    collapsableHeaderIds,
  } = flowTableData;

  if (isLoading) {
    return (
      <Box py="56">
        <Loading text="Loading" mx="auto" />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const { body, collapsableHeadersData, categories, tableAdditionalDetails } = data;
  const { hasHeaderSelected, toggleHeader, hasShowCollapsed, toggleShowCollapsed } = actions;

  return (
    <>
      <Box position="absolute" width="100%" left="0">
        <TableActions
          categories={categories}
          hasHeaderSelected={hasHeaderSelected}
          toggleHeader={toggleHeader}
          collapsableHeadersData={collapsableHeadersData}
          tableAdditionalDetails={tableAdditionalDetails}
          isSpouse={isSpouse}
        />

        <TableContent
          body={body}
          collapsableHeaderIds={collapsableHeaderIds}
          filteredCategoriesAndHeaders={filteredCategoriesAndHeaders}
          setTableHeight={setTableHeight}
          hasHeaderSelected={hasHeaderSelected}
          hasShowCollapsed={hasShowCollapsed}
          toggleShowCollapsed={toggleShowCollapsed}
          collapsableHeadersData={collapsableHeadersData}
        />
      </Box>

      <Box
        css={`
          height: calc(220px + ${tableHeight}px);
        `}
      />
    </>
  );
};
